// extracted by mini-css-extract-plugin
export default {"label":"MobileNavItem_label__H32i6"};